__turbopack_context__.v({
  "first-reset-iframe-btn": "IframePart-module-scss-module__YvE7YG__first-reset-iframe-btn",
  "reset-preview-wrapper": "IframePart-module-scss-module__YvE7YG__reset-preview-wrapper",
  "second-reset-iframe-btn": "IframePart-module-scss-module__YvE7YG__second-reset-iframe-btn",
});
